/**
 * @file: useTaskExtraInfo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { TaskExtraInfo } from '@euler/model/task-detail';
import { useBehaviorSubject } from '@euler/utils/hooks';

export const useTaskExtraInfo = (): TaskExtraInfo | undefined => {
  const { taskManager } = useTaskContext();
  const [extraInfo] = useBehaviorSubject(taskManager.extraInfo$);
  return extraInfo;
};
